// extracted by mini-css-extract-plugin
export default {"cls1":"PaperPreviewList-cls1_x1B","cls2":"PaperPreviewList-cls2_F1l PaperPreviewList-cls1_x1B"};